// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.StringFilterOperation
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSEnum.vm
// If you need to 'extend' the enum, create another file with module of the same name and add functions to it...

export let StringFilterOperation = /*#__PURE__*/function (StringFilterOperation) {
  StringFilterOperation[StringFilterOperation["None"] = 0] = "None";
  StringFilterOperation[StringFilterOperation["Contains"] = 1] = "Contains";
  StringFilterOperation[StringFilterOperation["Matches"] = 2] = "Matches";
  StringFilterOperation[StringFilterOperation["StartsWith"] = 3] = "StartsWith";
  StringFilterOperation[StringFilterOperation["EndsWith"] = 4] = "EndsWith";
  StringFilterOperation[StringFilterOperation["Specified"] = 5] = "Specified";
  return StringFilterOperation;
}({});
(function (_StringFilterOperation) {
  function fromJson(enumVal) {
    // Canonically always return numeric representation of enum (NOT a string!)
    // An enumVal of either string or number will return undefined if invalid (out of range)
    return typeof enumVal === "number"
    // For safety, check for number in range, if not return undefined
    ? StringFilterOperation[enumVal] != null ? enumVal : undefined : StringFilterOperation[enumVal];
  }
  _StringFilterOperation.fromJson = fromJson;
  function name(enumIndex) {
    return this[enumIndex];
  }
  _StringFilterOperation.name = name;
  function indexOf(enumVal) {
    return enumVal; // Erasure....
  }
  _StringFilterOperation.indexOf = indexOf;
})(StringFilterOperation || (StringFilterOperation = {}));
//# sourceMappingURL=StringFilterOperation.js.map
